/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 



/* Homepage logo */
$(function(){
  if($('.template-index').length > 0){
  	home_header();
  }
})

$(window).scroll(function(){
  home_header();
});

function home_header(){
  
   var scroll = $(window).scrollTop();
   var wHeight = $(window).height() - 30;
      if(scroll > wHeight){
        $('body').addClass('header--home');
    }
    else{
       $('body').removeClass('header--home');
    }

}

/* Scroll header */
$(function(){
  
  
  var scroll = $(window).scrollTop();
  if(scroll < 8){
    $('body').removeClass('scroll--header');
  }
  else{
     $('body').addClass('scroll--header');
  }
    
$(window).scroll(function(){
  var scroll = $(window).scrollTop();
    if(scroll < 8){
      $('body').removeClass('scroll--header');
    }
    else{
       $('body').addClass('scroll--header');
    }
  })
 
})


/* Page Sidebar class to body */
$(function(){
  if($('.page--sidebar').length > 0){
    $('body').addClass('features--page-sidebar'); 
  }
  $('#main').removeClass('no-sidebar');
  
});


/* Background Video resize */
function resize_video_slide(){
  
  if($('.section-background-video .ImageHero--fullbleed iframe').length > 0){

    var swidth = $('body').width();
    var sheight = $('.section-background-video .ImageHero--fullbleed').height();
    var aspectRatio = sheight/swidth;


    if( aspectRatio < .5625){
      $('.section-background-video .ImageHero--fullbleed iframe').width(swidth);
      var finalHeight = swidth*.5625;
      $('.section-background-video .ImageHero--fullbleed iframe').height(finalHeight)
    } else{
      $('.section-background-video .ImageHero--fullbleed iframe').height(sheight);
      var finalWidth = sheight*1.77;
      $('.section-background-video .ImageHero--fullbleed iframe').width(finalWidth)
    } 
  }
}

$(function(){
resize_video_slide();
  
  setTimeout(function(){
    resize_video_slide()}, 1000);
});

$(window).resize(function(){
  resize_video_slide();
});

/* Ingredient Carousel */


$(function(){
  if($('.Ingredient-Carousel').length > 0){
  var $ingredientCarousel = $('.Ingredient-Carousel').flickity(
    {
      freeScroll : true,
      prevNextButtons: false,
      pageDots: false
    }) 
  
  $(window).resize(function(){
    setTimeout(function(){
       $ingredientCarousel.flickity('resize');
    }, 200);
  });
  
  }
});


/* Add margin to merchandise layout products */
$(function(){
  if($('.Product:not(.Product--wine').length > 0){
   	var headerH =  $('.Header').height() +'px';
    $('.Product').css('margin-top', headerH);                    
  }
});


/* Wine Product Slider */
$(function(){
  if($('.Product__Gallery_Wine').length > 0){
  var $wineCarousel = $('.Product__Gallery_Wine').flickity(
    {
      prevNextButtons: false,
      pageDots: true,
    }) 
  
  $(window).resize(function(){
    setTimeout(function(){
       $wineCarousel.flickity('resize');
    }, 200);
  });
  
  }
});


/* Blog Slideshow */
$(function(){
  if($('.blog-slideshow').length > 0){
   $(".blog-slideshow .ArticleList").flickity(
      {
      prevNextButtons: false,
      pageDots: true,
        wrapAround: true,
        autoPlay: 5000,
    })
  }
});

/* Cart Gift Note */
$(function(){
  setTimeout(function(){
   cart_gift_note_init();
  }, 1000);
  
  setTimeout(function(){
   cart_gift_note_init();
  }, 2000);
  

  document.addEventListener('theme:loading:end', function() {
    setTimeout(function(){
     cart_gift_note_init();
    }, 1000);
    
    setTimeout(function(){
     cart_gift_note_init();
    }, 2000);
 });
  
});
  
  
  
function cart_gift_note_init(){
  $('.Gift_note_CTA').addClass('init');
  
  if($('.cart-gift-note-wrapper textarea').val() != ""){
    $('.Gift_note_CTA').text('edit your gift message');
  }
  
  $('.Gift_note_CTA').click(function(){
        $('.cart-gift-note-wrapper').addClass('active');
  });

  $('.cart-gift-note-close').click(function(){
      $('.cart-gift-note-wrapper').removeClass('active');
  });
  
   $('.cart-gift-note-button').click(function(e){
     e.preventDefault();
     e.stopPropagation();
      $('.cart-gift-note-wrapper').removeClass('active');
     $('.Gift_note_CTA').text('edit your gift message');
  });
}


/* Cart Upsell */

$(function(){
  setTimeout(function(){
   init_upsell();
  }, 1000);
  
})


document.addEventListener('theme:loading:end', function() {
    setTimeout(function(){
     init_upsell();
    }, 1000);
  
 });

function init_upsell(){
 $('.upsell-add_to_cart').each(function(){
    $(this).click(function(e){
      e.preventDefault();
      e.stopPropagation();
      
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', {
        bubbles: true
      }));

      var variant_id =  $(this).data('variant');

       let formData = {
        'items': [
            {
                'id': variant_id, 
                'quantity': 1
            }
        ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
        bubbles: true
      }));
    })
    .catch((error) => {
        console.log('Error:', error);
    });



    })

  })
}


/* Gift With Purchase */


$(function(){
  setTimeout(function(){
   init_gift();
  }, 1000);
  
})


document.addEventListener('theme:loading:end', function() {
    setTimeout(function(){
     init_gift();
    }, 1000);
  
 });


function isItemInCart(variantID) {
  
  let found = false;
 
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      
      for (const item of cart.items) {
        if (item.variant_id === variantID) { 
          found = true;
          break;
          
        }
      }
      return found;
    })
    .catch(error => {
      console.error('Error checking item in cart:', error);
      return false; 
    });
    
}



 function init_gift(){
   var progress_message = "test";
   var gift_threshold = $('.free-gift-bar-wrap').data('threshold')*100;
   var cart_total = $('.free-gift-bar-wrap').data('total');
   var gift_name = $('.free-gift-bar-wrap').data('product');
   var gift_id = $('.free-gift-bar-wrap').data('variant');
   var gift_in_cart = false;

    //check if reached threshold
   if (cart_total > gift_threshold){
      progress_message = "Enjoy your free "+gift_name;
      $('.free-gift-message-text').html(progress_message);
     
      //check if need to add gift to cart
      isItemInCart(gift_id).then(inCart => {
      if(!inCart){
                  // add gift to cart
          let formData = {
            'items': [
                {
                    'id': gift_id, 
                    'quantity': 1
                }
            ]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            //refresh cart
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            })); 
             setTimeout(function(){
              init_upsell();
              }, 1000);
          })
          .catch((error) => {
              console.log('Error:', error);
          });
      }
      });

   }else{
      var gift_difference = gift_threshold - cart_total;
      gift_difference= gift_difference/100;
      progress_message = "You are $"+gift_difference+" away from a free "+gift_name;
      $('.free-gift-message-text').html(progress_message);

      // check if item is in cart and remove it
      isItemInCart(gift_id).then(inCart => {
      if(inCart){
        console.log('remove item from cart: '+gift_id)

        let gift_update = {
          'id': gift_id.toString(),
          'quantity': 0
        }


       fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(gift_update)
          })
          .then(response => {
           
             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            })); 

             setTimeout(function(){
              init_upsell();
              }, 1000);

            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });

      
    }// end if
  })// end inCart
  }

    setTimeout(function(){
       $('.free-gift-message-text').html(progress_message);
    }, 1000); 

 }// end gift_init()


// Adding button styling to add/edit options in Bloom memberships account page

$(".bloom__body .button.btn").addClass("Button Button--primary").removeClass("button btn");
$(".bloom__body .select.js-saved-addresses").addClass("input-full");